import React, { useState } from 'react';
import Navbar from 'react-bootstrap/Navbar'
import NavDropdown from 'react-bootstrap/NavDropdown'
import i18n from './../../i18n';

import { useMsal } from "@azure/msal-react";
import signOut from './../../helpers/signOut';

export default function NavUserOptions() {

    const [lang, setLang] = useState(i18n.language);
    const { accounts } = useMsal();

    let userName = 'not authenticated user';
    let userFullName = '';
    if (accounts[0]) {
        userName = accounts[0].username ? accounts[0].username : 'not authenticated user';
        userFullName = accounts[0].username ? accounts[0].name : '';
    }
    
    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng, () => {
            setLang(lng);
        });
        console.log("change language to " + lng);
    }

    const signOutClickHandler = () => {
        signOut(accounts[0]);
    }

    return (
        <Navbar.Collapse id="navbarScroll" className="justify-content-end" title={userName}>
            <NavDropdown title={userFullName} id="navbarScrollingDropdown" className="navUserMenu">
                <NavDropdown.Item href="#" active={lang === 'es'? true : false} onClick={() => changeLanguage('es')}>{i18n.t('menuitem.lang.spanish')}</NavDropdown.Item>
                <NavDropdown.Item href="#" active={lang === 'en'? true : false} onClick={() => changeLanguage('en')}>{i18n.t('menuitem.lang.english')}</NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item href="#" onClick={() => signOutClickHandler()}>{i18n.t('menuitem.logout')}</NavDropdown.Item>
            </NavDropdown>
            <span>
                <svg xmlns="https://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-person-circle" viewBox="0 0 16 16">
                    <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z" />
                    <path fillRule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z" />
                </svg>
            </span>
        </Navbar.Collapse>
    )
}